/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PersonBasicInfo = {
  properties: {
    name: {
      type: 'string',
      isRequired: true,
    },
    cpf: {
      type: 'string',
      isRequired: true,
    },
    birthDate: {
      type: 'string',
      isRequired: true,
    },
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
  },
} as const;
